<template>
  <span>    
    <navbar></navbar>    
    <banner :routeName="routeName"></banner>    
    <detalle></detalle>  
    <whatsapp></whatsapp> 
    <my-footer></my-footer> 
  </span>
</template>

<script>
import MyFooter from '@/components/Home/MyFooter';
import Navbar from '@/components/Home/Navbar';
import Whatsapp from '@/components/Home/Whatsapp';
import Banner from "@/components/Home/Banner";
import Detalle from "@/components/Home/LibroReclamos";

export default {
  name: "Reclamos",
  components: {    
    Detalle,
    Banner,
    MyFooter,
    Navbar,
    Whatsapp   
  },  
  data () {
      return {
        routeName: 'Libro de reclamaciones',
      }    
    }  
    
};
</script>

<style scoped> 
</style>


// WEBPACK FOOTER //
// Reclamos.vue?59ac3d8c